import { useNavigate, useLocation, Navigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from 'react';
import { getDocs, query, where, collection, orderBy, limit, onSnapshot } from "firebase/firestore";
import { Helmet } from "react-helmet";
import { db } from "../firebase.js";
import Cookies from 'js-cookie';
import { Toast } from '../components_root/ToastContext';
import { MdOutlineAdminPanelSettings, MdReadMore, MdSettings, MdShare } from "react-icons/md";
import { RiPagesLine } from "react-icons/ri";
import { Randomcode } from "../components_root/rendom_code";
export const seo = {
    title: "Aooz Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    description: "Discover Aooz's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more. Enhance productivity with powerful tools for students, writers, developers, and businesses.",
    keywords: "Aooz services, free online tools, premium tools, seo tools, text utilities, file converters, image to pdf, favicon generator, word counter, productivity tools, online converters",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};


export default function Dashboard() {
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    const location = useLocation();
    const [guid, setguid] = useState(Cookies.get("guid"));
    const [companyuid, setcompanyuid] = useState(Cookies.get("website_company_uid"));

    useEffect(() => {
        if (!companyuid || !guid) return;

        const q = query(
            collection(db, "companies", companyuid, "admin_authentication"),
            where("accountguid", "==", guid),
            where("status", "==", true),
              where("dashboard", "==", true)
        );

        const unsubscribe = onSnapshot(
            q,
            (snapshot) => {
                if (!snapshot.empty) {
                    const data = snapshot.docs[0].data();
                } else {
                    navigate("/");
                }
            },
            (error) => {
                console.error("Realtime error:", error);
            }
        );

        // 🔥 Cleanup listener
        return () => unsubscribe();
    }, [companyuid, guid]);

    return (
        <div>

            <Helmet>
                <title>{seo.title}</title>
                <meta name="description" content={seo.description} />
                <meta name="keywords" content={seo.keywords} />
                <meta property="og:title" content={seo.title} />
                <meta property="og:description" content={seo.description} />
                <meta property="og:image" content={seo.image} />
                <meta property="og:url" content={seo.url} />
            </Helmet>

            <div className="container_roots b-top">
                <div >
                    <div className='post-container'>
                        <div className="post_post">
                            <div className="ui-grid">
                                <div className="ui-items items-back-fill rounded p-1 cursor">
                                    <table>
                                        <tr>
                                            <td width={30}><MdOutlineAdminPanelSettings className='icon' /></td>
                                            <td> <div className="text-h2 bold  ">Dashboard</div></td>
                                            <td width={30}> <div className="text-h2 "></div></td>
                                        </tr>
                                    </table>

                                </div>
                                <div className="ui-items items-back-fill rounded p-1 cursor" onClick={() => navigate("/editer-home")}>
                                    <table>
                                        <tr>
                                            <td width={30}><RiPagesLine className='icon' /></td>
                                            <td> <div className="text-h2  ">Contacts</div></td>
                                            <td width={30}> <div className="text-h2 ">0</div></td>
                                        </tr>
                                    </table>

                                </div>
                                <div className="ui-items items-back-fill rounded p-1 cursor" onClick={() => navigate("/editer-home")}>
                                    <table>
                                        <tr>
                                            <td width={30}><RiPagesLine className='icon' /></td>
                                            <td> <div className="text-h2  ">Leads</div></td>
                                            <td width={30}> <div className="text-h2 ">0</div></td>
                                        </tr>
                                    </table>

                                </div>
                                <div className="ui-items items-back-fill rounded p-1 cursor" onClick={() => navigate("/editer-home")}>
                                    <table>
                                        <tr>
                                            <td width={30}><RiPagesLine className='icon' /></td>
                                            <td> <div className="text-h2  ">Inquary</div></td>
                                            <td width={30}> <div className="text-h2 ">0</div></td>
                                        </tr>
                                    </table>

                                </div>

                            </div>
                        </div>
                        <div className='post_div'>
                            <div className="ui-grid">
                                <div className="ui-items b-1 rounded">
                                    <div className="ui-items p-02 b-bottom">
                                        <table>
                                            <tr>
                                                <td>
                                                    <div className="text-h2 bold">Inquary</div>
                                                </td>
                                                <td width={30}><MdReadMore className="icon cursor" /></td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div className="p-11">
                                        data list here
                                    </div>
                                </div>
                                <div className="ui-items b-1 rounded">
                                    <div className="ui-items p-02 b-bottom">
                                        <table>
                                            <tr>
                                                <td>
                                                    <div className="text-h2 bold">Users</div>
                                                </td>
                                                <td width={30}><MdReadMore className="icon cursor" /></td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div className="p-11">
                                        data list here
                                    </div>
                                </div>
                                <div className="ui-items b-1 rounded">
                                    <div className="ui-items p-02 b-bottom">
                                        <table>
                                            <tr>
                                                <td>
                                                    <div className="text-h2 bold">Visitor</div>
                                                </td>
                                                <td width={30}><MdReadMore className="icon cursor" /></td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div className="p-11">
                                        data list here
                                    </div>
                                </div>

                            </div>

                        </div>


                    </div>

                </div>
            </div>



        </div>
    );
}
